import { render, staticRenderFns } from "./OrderDesignate.vue?vue&type=template&id=4a71d78d&scoped=true"
import script from "./OrderDesignate.vue?vue&type=script&lang=js"
export * from "./OrderDesignate.vue?vue&type=script&lang=js"
import style0 from "./OrderDesignate.vue?vue&type=style&index=0&id=4a71d78d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71d78d",
  null
  
)

export default component.exports